import { SideNavigationService } from './../../base/side-navigation/side-navigation.service';
import { clientAdministrationRoute, userAdministrationRoute } from 'src/app/core/routing/route-names';
import { Injectable } from '@angular/core';

@Injectable()
export class AdministrationRoutesService {

  constructor(private sideNavService: SideNavigationService) { }

  public initializeNavigationData(): void {
    this.sideNavService.navigationData = [
      {
        designation: 'i18n.domain.administration.administration-routes.companies',
        route: clientAdministrationRoute
      },
      {
        designation: 'i18n.domain.administration.administration-routes.users',
        route: userAdministrationRoute
      }
    ]
  }
}